module.exports = __webpack_public_path__ + "static/media/declined.1ef16e1d.svg";